import { FC } from "react";

type IProps = {
  stroke?: string;
};

const TrashIcon: FC<IProps> = ({ stroke = "#6A6A6A" }) => {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.875 13.4375V4.25H11.375V13.4375C11.375 14.1758 10.7734 14.75 10.0625 14.75H2.1875C1.44922 14.75 0.875 14.1758 0.875 13.4375ZM8.3125 6.4375V12.5625C8.3125 12.8086 8.50391 13 8.75 13C8.96875 13 9.1875 12.8086 9.1875 12.5625V6.4375C9.1875 6.21875 8.96875 6 8.75 6C8.50391 6 8.3125 6.21875 8.3125 6.4375ZM5.6875 6.4375V12.5625C5.6875 12.8086 5.87891 13 6.125 13C6.34375 13 6.5625 12.8086 6.5625 12.5625V6.4375C6.5625 6.21875 6.34375 6 6.125 6C5.87891 6 5.6875 6.21875 5.6875 6.4375ZM3.0625 6.4375V12.5625C3.0625 12.8086 3.25391 13 3.5 13C3.71875 13 3.9375 12.8086 3.9375 12.5625V6.4375C3.9375 6.21875 3.71875 6 3.5 6C3.25391 6 3.0625 6.21875 3.0625 6.4375ZM11.8125 1.625C12.0312 1.625 12.25 1.84375 12.25 2.0625V2.9375C12.25 3.18359 12.0312 3.375 11.8125 3.375H0.4375C0.191406 3.375 0 3.18359 0 2.9375V2.0625C0 1.84375 0.191406 1.625 0.4375 1.625H3.71875L3.96484 1.13281C4.07422 0.914062 4.29297 0.75 4.53906 0.75H7.68359C7.92969 0.75 8.14844 0.914062 8.25781 1.13281L8.53125 1.625H11.8125Z"
        fill={stroke}
      />
    </svg>
  );
};

export default TrashIcon;
